export type SiteVisibilityUiState = {
  focus: boolean;
  labelsOff: boolean;
  orientationAxes: boolean;
};

export const SITE_VISIBILITY_UI_EVENT = "selected-site-visibility-options-changed";
/** Axes helper attached under the site group (matches legacy panel name). */
export const SITE_ORIENTATION_AXES_NAME = "__axesHelper";
export const SITE_ORIENTATION_UP_ARROW_NAME = "__upArrow";

export const DEFAULT_SITE_VISIBILITY_UI_STATE: SiteVisibilityUiState = {
  focus: false,
  labelsOff: true,
  orientationAxes: false,
};

let currentSiteVisibilityUiState: SiteVisibilityUiState = {
  ...DEFAULT_SITE_VISIBILITY_UI_STATE,
};

export function getSiteVisibilityUiState(): SiteVisibilityUiState {
  return { ...currentSiteVisibilityUiState };
}

export function setSiteVisibilityUiState(
  patch: Partial<SiteVisibilityUiState>
): SiteVisibilityUiState {
  currentSiteVisibilityUiState = {
    ...currentSiteVisibilityUiState,
    ...patch,
  };
  dispatchSiteVisibilityUiState(currentSiteVisibilityUiState);
  return getSiteVisibilityUiState();
}

export function dispatchSiteVisibilityUiState(state: SiteVisibilityUiState): void {
  currentSiteVisibilityUiState = { ...state };
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(SITE_VISIBILITY_UI_EVENT, {
      detail: { ...state },
    })
  );
}
